export default __webpack_public_path__ + "assets/images/Payment_12.56e64f.png";